<ng-container *transloco="let t; scope: 'notificacoes'">
  <div class="row">
    <div class="col-xxl-12">
      <nb-card [nbSpinner]="loading">
        <nb-card-header>
          <div class="row">
            <div class="col-12 col-md-6 align-self-center">{{ t('notificacoes.titulo') }}</div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <div class="notificacoes-filtros">
            <button nbButton status="primary" size="medium" (click)="handleMarcarLidas()">{{ t('notificacoes.marcarLidas') }}</button>
            <nb-checkbox [(ngModel)]="mostrarLidas" (click)="handleMostrarNaoLidas()">   {{ t('notificacoes.mostrarNaoLidas') }}</nb-checkbox>
          </div>
          <div class="accordion-notificacao">
            <nb-accordion multi *ngIf="objNotificacoes.length > 0">
              <nb-accordion-item *ngFor="let not of objNotificacoes; index as i;">
                <nb-accordion-item-header (click)="handleClickNotificacao(not)" class="notificacao-header" [ngClass]="not.dataLeitura === null ? 'notificacao-bold' : ''">
                  {{not.dataCriacaoFormat}} - {{not.titulo}}
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <div class="notificacao-content">
                    {{not.resumo}}
                  </div>
                  <div *ngIf="not.url !== null">
                    <button nbButton size="small" status="primary" (click)="handleLink(not)">{{ t('notificacoes.acessarLink') }}</button>
                  </div>
                </nb-accordion-item-body>
              </nb-accordion-item>
            </nb-accordion>
          </div>
          <div *ngIf="showEmptyMessage" class="notificacao-message">
            {{t('notificacoes.semNotificacoes')}}
          </div>
        </nb-card-body>
        <nb-card-footer>
        </nb-card-footer>
      </nb-card>
    </div>
  </div>
</ng-container>
